import { StatsigClient } from '@statsig/react-bindings';
import { Ecommerce } from './events/ecommerce/types';
import { statsigFilters } from './events/statsigFilters';
import { GAEventName } from './ga-event-name.enum';
import { DataLayerEvent } from './types';

export const ALLOWED_STATSIG_EVENTS: ReadonlySet<GAEventName> = new Set([
  GAEventName.ADD_PAYMENT_INFO,
  GAEventName.ADD_SHIPPING_INFO,
  GAEventName.ADD_TO_CART,
  GAEventName.APPLY_DISCOUNT_FAILURE,
  GAEventName.APPLY_DISCOUNT_SUCCESS,
  GAEventName.BEGIN_CHECKOUT,
  GAEventName.CHANGE_SHIPPING_INFO,
  GAEventName.CHECKOUT,
  GAEventName.CHECKOUT_CANCEL,
  GAEventName.CHECKOUT_ERROR,
  GAEventName.DELETE_SAVED_ADDRESS_CHECKOUT,
  GAEventName.DELETE_SAVED_PAYMENT_CHECKOUT,
  GAEventName.EDIT_PAYMENT_METHOD_CHECKOUT,
  GAEventName.EXPRESS_CHECKOUT,
  GAEventName.EXPRESS_CHECKOUT_CUSTOM_EVENT,
  GAEventName.EXPRESS_CHECKOUT_ATTEMPT,
  GAEventName.EXPRESS_CHECKOUT_FAILURE,
  GAEventName.ORDER_DETAIL_REVIEW,
  GAEventName.PURCHASE,
  GAEventName.REMOVE_FROM_CART,
  GAEventName.REVIEW_ORDER,
  GAEventName.SUBSCRIPTION_PAYMENT_INFO,
  GAEventName.SUBSCRIPTION_SHIPMENT_FREQUENCY,
  GAEventName.THANKS_TRUEMED_LOAD,
  GAEventName.VIEW_CART,
  GAEventName.VIEW_ITEM_LIST,
  GAEventName.PRODUCT_SELECTION,
  GAEventName.SUBSCRIPTION_SELECTION,
  GAEventName.SUB_AND_SAVE_TOGGLE,
  GAEventName.USE_SAVED_ADDRESS_CHECKOUT,
  GAEventName.VIEW_CONTENT,
  GAEventName.SWAP_TO_TRAVELPACK,
  GAEventName.SWAP_TO_POUCH,
  GAEventName.NEXT_ORDER_ONLY
]);

export const logStatsigEvent = (event: DataLayerEvent) => {
  const eventName = event.event || event.event_name;
  const eventEcommerce = event.ecommerce as Ecommerce | undefined;

  if (!eventName) return;

  const itemData = eventEcommerce?.items?.[0];
  if (ALLOWED_STATSIG_EVENTS.has(eventName as GAEventName)) {
    let filteredEvent = null;

    if (statsigFilters[eventName]) {
      filteredEvent = statsigFilters[eventName](event);
    } else {
      filteredEvent = itemData || event;
    }

    if (itemData) {
      const itemId = itemData.variant_id || itemData.item_id || '';
      StatsigClient.instance().logEvent(eventName, itemId, filteredEvent as Record<string, string>);
    } else {
      const eventValue =
        filteredEvent.shopify_id || filteredEvent.subscription_id || filteredEvent.coupon || '';
      StatsigClient.instance().logEvent(
        eventName,
        eventValue.toString(),
        filteredEvent as Record<string, string>
      );
    }
  }
};
